import { Box, Grid, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Image from '../../Assets/assetHelper';
import { ReactChildren } from '../../interfaces/Common';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: '100vh',
    width: '100vw',
    position: 'relative',
    background: 'linear-gradient(256deg, #282828 4.22%, #280D00 100%) !important',
  },
  formContainer: {
    background: '#FAFAFA',
    margin: '12px',
    borderRadius: '24px',
    height: '98vh',
  },
  leftContainer: {
    position: 'relative',
    height: '100%',
    width: '100%',
    backgroundImage: `url(${Image.Images.authLayoutBG})`,
    backgroundSize: 'cover !important',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  copywrite: {
    fontSize: '14px !important',
    fontWeight: '500',
    color: '#8A8A8A',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '10.5px !important',
    },
  },
  loginVector: {
    height: '330px',
    opacity: '0.1',
    [theme.breakpoints.down('md')]: {
      height: '230px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '130px',
    },
  },
  logo: {
    position: 'absolute',
    top: '52%',
    [theme.breakpoints.down('ultraHD')]: { top: '42%' },
    left: '-7%',
    opacity: '10%',
    width: '661px',
    height: '661px',
    zIndex: 1,
  },
}));

const AuthLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} md={6} sx={{display:{ xs: 'none', md: 'flex' }}}>
        <Box className={classes.leftContainer}>
          <Box
            sx={{
              padding: '1px',
              borderRadius: '16px',
              background: 'linear-gradient(120deg, #666666 0%, #000000 50%, #666666 100%)',
              display: 'inline-block',
            }}
          >
            <Box
              sx={{
                backgroundColor: '#000000',
                borderRadius: '14px',
                padding: '24px 40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img src={Image.Svg.IdeabaazLogo} alt="Ideabaaz Logo" style={{ maxWidth: '100%', height: 'auto' }} />
            </Box>
          </Box>
          <Box sx={{ position: 'absolute', bottom: 40, left: 40 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box sx={{ borderLeft: '1px solid #D8D8D8', pl: '14px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#F3F5FB', pl: '4px' }}>Powered by</Typography>
                <img src={Image.Images.turbostartLogo} alt="Ideabaaz Logo" style={{ maxWidth: '100%', height: '40px' }} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6} sx={{ backgroundColor: '#110C0E' }}>
        <Box className={classes.formContainer}>{children}</Box>
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
